<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-temporary-full`]" width="1em" height="1em" v-bind="$attrs"><path d="M98.1820911,88.3635818 L64.3001443,88.3635818 C64.0239809,89.8497611 63.8182091,91.4474564 63.8182091,93.2731366 C63.8182091,103.091046 73.6367184,103.091046 73.6367184,103.091046 C76.3477724,103.091046 78.5456729,104.190296 78.5456729,105.545748 C78.5456729,106.90135 76.3477724,108 73.6367184,108 L34.363882,108 C31.6523777,108 29.4543271,106.90135 29.4543271,105.545748 C29.4543271,104.190296 31.6523777,103.091046 34.363882,103.091046 C34.363882,103.091046 44.1817909,103.091046 44.1817909,93.2731366 C44.1817909,91.4474564 43.9760191,89.8497611 43.6998557,88.3635818 L9.81790893,88.3635818 C4.39535058,88.3635818 0,83.9682312 0,78.5456729 L0,9.81790893 C0,4.39535058 4.39535058,0 9.81790893,0 L98.1820911,0 C103.604649,0 108,4.39535058 108,9.81790893 L108,78.5456729 C108,83.9682312 103.604649,88.3635818 98.1820911,88.3635818 Z M9.45,68.85 L98.55,68.85 L98.55,10.8 L9.45,10.8 L9.45,68.85 Z" transform="translate(11 11)" :fill="useCurrentColor ? 'currentColor' : '#86909C'" fill-rule="evenodd"/></svg>
</template>
<script>

export default {
  name: 'IconPsmTemporaryFull',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
